import { Border } from '../border.model';
import { Css } from '../css.model';
import { Margin } from '../margin.model';
import { Media } from '../media.model';
import { Padding } from '../padding.model';

export class Map {
  ApiKey: string = '';
  MapId: string = '';
  Latitude: number = 0;
  Longitude: number = 0;
  Zoom: number = 0;
  MapType: string = '';
  MarkerIcon: string = '';
  MarkerTitle: string = '';
  MarkerDescription: string = '';
  Width: string = '';
  Height: string = '';
  ZoomWithScrollwheel = true;
  CookieConsentText: string = '';
  // Padding: Padding = new Padding();
  // Border: Border = new Border();
  // Margin: Margin = new Margin();
  Css: Css = new Css();
  Marker: Media = new Media();
  Styles?: string[];
}
